import {PersistedChallengeState} from './types';

const getChallengeKey = (userId: string | number) =>
  `puzzle_challenge_${userId}`;

export function saveChallengeState(
  userId: string | number,
  state: PersistedChallengeState,
): void {
  try {
    localStorage.setItem(getChallengeKey(userId), JSON.stringify(state));
  } catch {}
}

export function loadChallengeState(
  userId: string | number,
): PersistedChallengeState | null {
  try {
    const raw = localStorage.getItem(getChallengeKey(userId));
    if (!raw) return null;
    return JSON.parse(raw) as PersistedChallengeState;
  } catch {
    return null;
  }
}

export function clearChallengeState(userId: string | number): void {
  try {
    localStorage.removeItem(getChallengeKey(userId));
  } catch {}
}
